<template>
  <div class="range-slider">
    <div class="range-number">
      <input
        disabled
        type="number"
        min="0"
        max="100"
        step="1"
        v-model="sliderMin"
      />
      <label style="padding: 0px 148px">Select Age Range</label>
      <input
        disabled
        type="number"
        min="0"
        max="100"
        step="1"
        v-model="sliderMax"
      />
    </div>
    <div>
      <input
        type="range"
        min="0"
        max="100"
        step="1"
        v-model="sliderMin"
        @input="(sliderMin) => $emit('minValue', sliderMin)"
      />
      <input
        type="range"
        min="0"
        max="100"
        step="1"
        v-model="sliderMax"
        @input="(sliderMax) => $emit('maxValue', sliderMax)"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "RangeSlider",
  data() {
    return {
      minAngle: 0,
      maxAngle: 100,
    };
  },
  computed: {
    sliderMin: {
      get: function () {
        var val = parseInt(this.minAngle);
        return val;
      },
      set: function (val) {
        val = parseInt(val);
        if (val > this.maxAngle) {
          this.maxAngle = val;
        }
        this.minAngle = val;
      },
    },
    sliderMax: {
      get: function () {
        var val = parseInt(this.maxAngle);
        return val;
      },
      set: function (val) {
        val = parseInt(val);
        if (val < this.minAngle) {
          this.minAngle = val;
        }
        this.maxAngle = val;
      },
    },
  },
};
</script>

<style scoped>
.range-slider {
  width: auto;
  margin: auto;
  text-align: center;
}

.range-number {
  padding-bottom: 10px;
}

.range-slider input[type="range"] {
  position: absolute;
  left: 18px;
}

input[type="number"] {
  border: 1px solid #ddd;
  border-radius: 10px;
  background-color: rgb(182, 243, 235);
  text-align: center;
  font-size: 1em;
  font-weight: 800;
}

input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

input[type="number"]:invalid,
input[type="number"]:out-of-range {
  border: 2px solid #ff6347;
}

input[type="range"] {
  -webkit-appearance: none;
  width: 95%;
}

input[type="range"]:focus {
  outline: none;
}

input[type="range"]:focus::-webkit-slider-runnable-track {
  background: #2497e3;
}

input[type="range"]:focus::-ms-fill-lower {
  background: #2497e3;
}

input[type="range"]:focus::-ms-fill-upper {
  background: #2497e3;
}

input[type="range"]::-webkit-slider-runnable-track {
  width: 100%;
  height: 5px;
  cursor: pointer;
  background: #2497e3;
  border-radius: 1px;
  box-shadow: none;
  border: 0;
}

input[type="range"]::-webkit-slider-thumb {
  z-index: 2;
  position: relative;
  box-shadow: 0px 0px 0px #000;
  border: 1px solid #2497e3;
  height: 18px;
  width: 18px;
  border-radius: 25px;
  background: #a1d0ff;
  cursor: pointer;
  -webkit-appearance: none;
  margin-top: -7px;
}
</style>
